// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3-W-F","title":"styles_title__lZY9o"};